import React, { Component } from 'react';
import { Modal, Table } from 'antd';
import util from '@util';
import moment from 'moment';
import getAllType from '@util/getAllType';

class ModalRecycle extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    getAllType().then(res => {
      this.setState({
        type: res,
      });
    });
  }

  handleTableChange = pagination => {
    this.props.onChange(pagination.current);
  };

  columns = () => {
    const { type } = this.state;
    return [
      {
        title: '日期',
        dataIndex: 'date',
        key: 'date',
        width: 250,
        render: (text, record) => {
          let ignoreName;
          switch (record.ignore) {
            case 0:
              ignoreName = '';
              break;
            case 1:
              ignoreName = '(非业务数据)';
              break;
            case 2:
              ignoreName = '(走账数据)';
              break;
            default:
              ignoreName = '';
              break;
          }
          return (
            <span>
              {moment.unix(text / 1000).format('YYYY-MM-DD')} {ignoreName}
            </span>
          );
        },
      },
      {
        title: '对方户名',
        dataIndex: 'accountName',
        key: 'accountName',
        width: 200,
      },
      {
        title: '摘要',
        dataIndex: 'remark',
        key: 'remark',
        width: 200,
      },
      {
        title: '收支类型',
        dataIndex: 'type',
        key: 'type',
        width: 200,
        render: text => {
          let typeName = '';
          if (type.length > 0) {
            type.forEach(item => {
              if (text === item.value) {
                typeName = item.key;
                return typeName;
              }
            });
          }
          return <span>{typeName}</span>;
        },
      },
      {
        title: '收入(元)',
        dataIndex: 'money',
        key: 'money',
        width: 200,
        render: text => (
          <a style={{ color: 'green' }}>{text === 0 ? '' : util.numberFormat(text, 2, '.', ',')}</a>
        ),
      },
      {
        title: '支出(元)',
        dataIndex: 'payMoney',
        key: 'payMoney',
        width: 200,
        render: text => (
          <a style={{ color: 'red' }}>{text === 0 ? '' : util.numberFormat(text, 2, '.', ',')}</a>
        ),
      },
      {
        title: '当前余额(元)',
        dataIndex: 'current',
        key: 'current',
        width: 200,
        render: text => <span>{text === 0 ? '' : util.numberFormat(text, 2, '.', ',')}</span>,
      },
    ];
  };

  render() {
    const { data, visible, pagination } = this.props;
    return (
      <Modal
        title="回收箱"
        footer={null}
        visible={visible}
        onCancel={this.props.onCancel}
        width="80%"
      >
        <Table
          rowKey="uuid"
          dataSource={data}
          pagination={pagination}
          columns={this.columns()}
          onChange={this.handleTableChange}
        />
      </Modal>
    );
  }
}

export default ModalRecycle;



// WEBPACK FOOTER //
// ./src/components/finance/capital/detail/ModalRemove.js